export default {
  Title: 'Phiếu xuất kho',
  FullName: 'Họ tên',
  Address: 'Địa chỉ',
  Deliver: 'Người nhận',
  Description: 'Diễn giải',
  TKKB: 'TKKB',
  Attach: 'Kèm theo',
  Reference: 'CT tham chiếu',
  TextTooltip: {
    TKKB: 'Tài khoản kho bạc',
    RefDate: 'Ngày Chứng từ',
    PostedDate: 'Ngày Hạch toán',
    RefNo: 'Số Chứng từ',
  },
  PopupCheckInventoryCode: {
    Message: 'Chưa nhập vật tư',
    Title: 'Cất không thành công',
    Button: 'Đồng ý',
  },
  PopupCheckStock: {
    Message: 'Chưa nhập kho',
    Title: 'Cất không thành công',
    Button: 'Đồng ý',
  },
  PopupCheckAmount: {
    Content: 'Số ký tự cột thành tiền vượt quá số lượng quy định (14 ký tự). Vui lòng kiểm tra lại.',
    Title: 'Không hợp lệ',
  },
};
